import React from "react";
import { TextField } from "@material-ui/core";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import { BookingStatusType as Status, BookingProfileFragment } from "@graphql";
import locale from "@bonliva-crm/locale";

type BookingStatusProps = { data: BookingProfileFragment };

export function BookingStatus({ data }: BookingStatusProps) {
  const bookingStatus = getBookingStatus(data);

  return (
    <TextField
      fullWidth
      style={{ marginBottom: 10 }}
      color="secondary"
      label={locale.BookingStatus}
      value={bookingStatus.label}
      InputProps={{
        startAdornment: <FiberManualRecord style={{ color: bookingStatus.color }} />,
        readOnly: true
      }}
    />
  );
}

const Color = {
  Initial: "#cccccc",
  Canceled: "#ffa1a1",
  InProgress: "#f2deae",
  Done: "#bad6a5"
} as const;

function getBookingStatus(data: BookingProfileFragment) {
  const status = data.bookingStatus?.status;

  const statusColorMap: Record<Status, string> = {
    [Status.Closed]: Color.Done,
    [Status.Billed]: Color.InProgress,
    [Status.Paid]: Color.InProgress,
    [Status.Open]: Color.Initial,
    [Status.Canceled]: Color.Canceled
  };

  return {
    status,
    color: statusColorMap[status] ?? Color.Initial,
    label: locale.bookingStatus[status]
  };
}
